module.exports = __webpack_public_path__ + "img/discount_background.66b7514.png";